import { c as _c } from "react/compiler-runtime";
import { FlexColumn, Separator } from "@opensea/ui-kit";
export const ReceiptDisplay = t0 => {
  const $ = _c(6);
  const {
    receipt,
    receiptTotal
  } = t0;
  let t1;
  if ($[0] !== receiptTotal) {
    t1 = receiptTotal && <Separator className="my-2" />;
    $[0] = receiptTotal;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== receipt || $[3] !== receiptTotal || $[4] !== t1) {
    t2 = <FlexColumn className="w-full">{receipt}{t1}{receiptTotal}</FlexColumn>;
    $[2] = receipt;
    $[3] = receiptTotal;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};